import React from "react";

interface Props {
    project: any;
    className?: string;
}

export const integrationNames: { [key: string]: string } = {
    procore: "Procore",
    procore_sandbox: "Procore",
    autodesk_construction: "Autodesk Build",
};

export const IntegrationName: React.FC<Props> = ({ project, className }) => {
    const integrationName = integrationNames[project.integration_source];

    return <span className={className}>{integrationName}</span>;
};
